// src/models/caixas/TipoMovCaixa.js
export const TipoMovCaixa = Object.freeze({
    Abertura: 1,
    Suprimento: 2,
    Fechamento: 3,
    Sangria: 4,
    LancamentoManual: 5,
    LancamentoAutomatico: 6
});


export const getDescricaoTipoMov = (value) => {
    switch (parseInt(value)) {
      case 1:
        return 'Abertura';
      case 2:
        return 'Suprimento';
      case 3:
        return 'Fechamento';
      case 4:
        return 'Sangria';
      default:
        return 'Movimentação desconhecida';
    }
  };
